/* eslint-disable @typescript-eslint/no-explicit-any */
import {
    AccountESignature,
    Address,
    AddTrustedContact,
    AdvisoryESignature,
    Affiliation,
    AutoInvestSetSchedule,
    FirstDepositSummary,
    BankLinkContainer,
    BillingSummary,
    ConsolidatedQuestions,
    Country,
    DuplicateSSNBlockScreen,
    EmploymentStatus,
    IdentityVerificationError,
    IdentityVerificationLoader,
    IdentityVerificationSuccess,
    IdentityVerificationWaitingRoom,
    InvestmentDetail,
    InvestmentSelection,
    LegalNameAndCitizenshipAndDob,
    LinkBankPrimer,
    OnboardingComplete,
    PhoneNumber,
    PhoneNumberVerification,
    SmartPortfolio,
    FirstDepositSuccess,
    SmartPortfolioTransitionScreen,
    SocialSecurityNumber,
    StateZeroHome,
    StateZeroPrimer,
    TierSelection,
    TrustedContact,
    Visa,
    WelcomeToStash,
    BankLinkOAuth,
    GoalRouter,

    FirstNameContainer,
} from 'stash/components/screens/chunks';
import * as store from 'stash/apps/transitions';
import { Step } from 'stash/graph/types';

export const OnboardingStepsVoaM3: Record<string, Step> = {
    'first-name': {
        path: '/first-name',
        component: FirstNameContainer,
        props: {},
    },
    'goal': {
        path: '/goal*',
        component: GoalRouter,
        props: {},
    },
    'phone-number': {
        path: '/phone-number',
        component: PhoneNumber,
        props: {},
    },
    'verify-phone-number': {
        path: '/verify-phone-number',
        component: PhoneNumberVerification,
        props: {},
    },
    'personal-info': {
        path: '/personal-info',
        component: LegalNameAndCitizenshipAndDob,
        props: {},
    },
    'welcome-to-stash': {
        path: '/welcome-to-stash',
        component: WelcomeToStash,
        props: {},
    },
    'add-trusted-contact': {
        path: '/add-trusted-contact',
        component: AddTrustedContact,
        props: {},
    },
    'trusted-contact': {
        path: '/trusted-contact',
        component: TrustedContact,
        props: {},
    },
    country: {
        path: '/country',
        component: Country,
        props: {},
    },
    visa: {
        path: '/visa',
        component: Visa,
        props: {},
    },
    'investing-experience': {
        path: '/investing-experience',
        component: ConsolidatedQuestions,
        props: {},
    },
    'employment-status': {
        path: '/employment-info',
        component: EmploymentStatus,
        props: {},
    },
    ssn: {
        path: '/ssn',
        component: SocialSecurityNumber,
        props: {},
    },
    'identity-verification-loader': {
        path: '/idv-loader',
        component: IdentityVerificationLoader,
        props: {},
    },
    // for users in the later SSN entry screen flow
    'legacy-identity-verification-loader': {
        path: '/legacy-idv-loader',
        component: IdentityVerificationLoader,
        props: {},
    },
    'identity-verification-error': {
        path: '/idv-error',
        component: IdentityVerificationError,
        props: {},
    },
    'identity-verification-success': {
        path: '/idv-success',
        component: IdentityVerificationSuccess,
        props: {},
    },
    // for users in the later SSN entry screen flow
    'legacy-identity-verification-success': {
        path: '/legacy-idv-success',
        component: IdentityVerificationSuccess,
        props: {},
    },
    'identity-verification-waiting-room': {
        path: '/idv-waiting-room',
        component: IdentityVerificationWaitingRoom,
        props: {},
    },
    // for users in the later SSN entry screen flow
    'legacy-identity-verification-waiting-room': {
        path: '/legacy-idv-waiting-room',
        component: IdentityVerificationWaitingRoom,
        props: {},
    },
    address: {
        path: '/address',
        component: Address,
        props: {},
    },
    affiliation: {
        path: '/affiliation',
        component: Affiliation,
        props: {},
    },
    'legacy-ssn': {
        path: '/legacy-ssn',
        component: SocialSecurityNumber,
        props: {},
    },
    'account-options': {
        path: '/account-options',
        component: TierSelection,
        props: {},
    },
    'advisory-agreement': {
        path: '/advisory-agreement',
        component: AdvisoryESignature,
        props: {},
    },
    'state-zero': {
        path: '/state-zero',
        component: StateZeroHome,
        props: {},
    },
    'state-zero-primer': {
        path: '/state-zero-primer',
        component: StateZeroPrimer,
        props: {},
    },
    'e-sign': {
        path: '/e-sign',
        component: AccountESignature,
        props: {},
    },
    'investment-selection': {
        path: '/investment-selection',
        component: InvestmentSelection,
        props: {},
    },
    'investment-detail': {
        path: '/investment-detail',
        component: InvestmentDetail,
        props: {},
    },
    'smart-setup': {
        path: '/smart-setup',
        component: SmartPortfolioTransitionScreen,
    },
    'ssn-block': {
        path: '/ssn-block',
        component: DuplicateSSNBlockScreen,
    },
    'smart-mix': {
        path: '/smart-mix',
        component: SmartPortfolio,
        props: {},
    },
    'set-auto-invest-schedule': {
        path: '/set-auto-invest-schedule',
        component: AutoInvestSetSchedule,
        props: {},
    },
    'link-bank-primer': {
        path: '/link-bank-primer',
        component: LinkBankPrimer,
        props: {},
    },
    'link-bank': {
        path: '/link-bank',
        component: BankLinkContainer,
        props: {},
    },
    'billing-summary': {
        path: '/billing-summary',
        component: BillingSummary,
        props: {},
    },
    'first-deposit-summary': {
        path: '/first-deposit-summary',
        component: FirstDepositSummary,
        props: {},
    },
    'first-deposit-success': {
        path: '/first-deposit-success',
        component: FirstDepositSuccess,
        props: {},
    },
    referral: {
        path: '/referral',
        component: OnboardingComplete,
        props: {},
        redirectToWebApp: true,
    },
    'link-bank-oauth': {
        path: '/link-bank/oauth',
        component: BankLinkOAuth,
        props: {},
    },
};

export const OnboardingTransitionsVoAM3: Record<string, any[]> = {
    'first-name': [
        // The below order matters
        [store.hasBankLinkOAuthSession, 'link-bank-oauth'],
        [store.hasBankLinkOAuthRedirectUri, 'link-bank'],
        [store.hasFirstName, 'goal'],
    ],
    'goal': [
        [store.hasAnsweredGoalQuestion, 'phone-number'],
    ],
    'phone-number': [
        [store.hasPhoneNumber, 'verify-phone-number'],
    ],
    'verify-phone-number': [[store.hasVerifiedPhoneNumber, 'personal-info']],
    'personal-info': [
        [store.hasFirstLastNameAndUSCitizenshipAndDOB, 'address'],
        [store.hasGreenCardAndDOB, 'country'],
        [store.hasNoGreenCardAndDOB, 'visa'],
    ],
    visa: [[store.hasEligibleVisa, 'country']],
    country: [[store.hasCitizenshipCountry, 'address']],
    address: [
        [store.hasAdvisorySignatureAndAddress, 'state-zero'], // needed for existing content moat users & state zero screen
        [store.hasAddress, 'ssn'],
    ],
    ssn: [
        [store.setDuplicateSSNBlockScreen, 'ssn-block'],
        [store.hasAdvisorySignature, 'state-zero'], // needed for existing content moat users & state zero screen
        [store.hasIdvAsCelebrationAndPxQuestionIdvStatusComplete, 'account-options'],
        [store.hasSSNComplete, 'identity-verification-loader'],
    ],
    'identity-verification-loader': [
        [store.hasIdvAsCelebrationAndPxQuestionIdvStatusComplete, 'account-options'],
        [store.hasIdvVerificationLoaderCompleteWithNextScreenAsCelebration, 'identity-verification-success'],
        [store.hasIdvVerificationLoaderCompleteWithNextScreenAsManualReview, 'identity-verification-waiting-room'],
        [store.hasIdvVerificationLoaderCompleteWithNextScreenAsError, 'identity-verification-error'],
    ],
    'identity-verification-error': [
        // No transitions. This screen is a dead end.
    ],
    'identity-verification-success': [
        [store.hasIDVSuccessCompleteAndNoAdvisoryEsig, 'account-options'],
    ],
    'identity-verification-waiting-room': [
        // No transitions. This screen has a soft redirect to State zero to avoid cycle formation in DAG
    ],
    'account-options': [
        [store.hasPlanSelectionCompleteAndCurrentPlan, 'billing-summary'], // New transition for Dynamic plans
    ],
    'billing-summary': [
        [store.hasAdvisorySignature, 'state-zero'],
        [store.completedBillingSummary, 'advisory-agreement'],
    ],
    'advisory-agreement': [[store.hasAdvisorySignature, 'welcome-to-stash']],
    'welcome-to-stash': [
        // Do not change the order of below transitions
        [store.completedWelcomeToStashWithNoSmartEntitlement, 'state-zero-primer'], // tranistion for new users who does NOT have the smart entitlement
        [store.completedWelcomeToStash, 'state-zero'],
    ],
    'state-zero': [
        [store.hasStateZeroHomeCompleteWithIdvStatusAndHardFail, 'identity-verification-error'],
        [store.hasStateZeroWithPersonal, 'investment-selection'],
        [store.hasStateZeroWithSmart, 'smart-mix'],
        [store.hasStateZeroHomeV2CompleteWithIdvAsCelebrationAndPxQuestionIdvStatusComplete, 'employment-status'],
        [store.hasStateZeroHomeV2CompleteWithSsnAndIdvAsNotCelebrationAndPxQuestionIdvStatusNotComplete, 'legacy-identity-verification-loader'],
        [store.hasStateZeroHomeV2CompleteWithNoSsn, 'legacy-ssn'],
        [store.hasStateZeroHomeCompleteWithSkipStateZeroPrimer, 'employment-status'],
        [store.hasStateZeroHomeComplete, 'state-zero-primer'],
        [store.hasReturnToIdvFlow, 'legacy-identity-verification-loader'],
        // Do not change the order of below transitions
        [store.hasAccountSignatureAndNoSmartEntitlement, 'investment-selection'], // transition for returning users (Post AccountEsig) who does NOT have the smart entitlement going to investment selection
        [store.hasAdvisorySignatureAndNoSmartEntitlement, 'state-zero-primer'], //transition for returning users who  does NOT have the smart entitlement going to state zero primer
    ],
    'state-zero-primer': [
        [store.hasStateZeroPrimerCompleteWithIdvAsCelebrationAndPxQuestionIdvStatusComplete, 'employment-status'],
        [store.hasStateZeroPrimerCompleteWithSsnAndIdvAsNotCelebrationAndPxQuestionIdvStatusNotComplete, 'legacy-identity-verification-loader'],
        [store.hasStateZeroPrimerCompleteWithNoSsn, 'legacy-ssn'],
    ],
    'legacy-ssn': [
        [store.hasIdvAsCelebrationAndPxQuestionIdvStatusComplete, 'employment-status'],
        [store.hasSSNComplete, 'legacy-identity-verification-loader'],
    ],
    'legacy-identity-verification-loader': [
        [store.hasIdvAsCelebrationAndPxQuestionIdvStatusComplete, 'employment-status'],
        [store.hasIdvVerificationLoaderCompleteWithNextScreenAsCelebration, 'legacy-identity-verification-success'],
        [store.hasIdvVerificationLoaderCompleteWithNextScreenAsManualReview, 'legacy-identity-verification-waiting-room'],
        [store.hasIdvVerificationLoaderCompleteWithNextScreenAsError, 'identity-verification-error'],
    ],
    'legacy-identity-verification-success': [
        [store.hasIDVSuccessCompleteWithAdvisoryEsig, 'employment-status'],
    ],
    'employment-status': [
        [store.hasNonFulltimeEmployment, 'investing-experience'],
        [store.hasEmployer, 'investing-experience'],
    ],
    'investing-experience': [
        [store.hasCompletedInvestingExperience, 'affiliation'],
    ],
    affiliation: [
        [store.hasAffiliation, 'add-trusted-contact'],
    ],
    'add-trusted-contact': [
        [store.completedAddTrustedContact, 'trusted-contact'],
        [store.hasOptedOutTrustedContact, 'e-sign'],
    ],
    'trusted-contact': [
        [store.hasOptedOutTrustedContact, 'e-sign'],
        [store.completedTrustedContact, 'e-sign'],
    ],
    'e-sign': [
        // Do not change the order of below transitions
        [store.hasBankLinkedWithDatabaseTransaction, 'referral'], // TODO: check if still valid
        [store.hasStateZeroWithPersonal, 'investment-selection'],
        [store.hasStateZeroWithSmart, 'smart-setup'],
        [store.hasInvestEsigWithNoNextStep, 'smart-setup'],
    ],
    'investment-selection': [
        [store.skipToLinkBankPrimer, 'link-bank-primer'],
        [store.hasInvestmentSelectionComplete, 'investment-detail'],
        [store.hasInvestmentDetailComplete, 'set-auto-invest-schedule'],
    ],
    'investment-detail': [
        [store.hasInvestmentDetailComplete, 'set-auto-invest-schedule'],
    ],
    'smart-setup': [
        [store.hasSmartPortfolioTransitionComplete, 'smart-mix'],
    ],
    'smart-mix': [
        [store.skipToLinkBankPrimer, 'link-bank-primer'],
        [store.setSmartPortfolioAllocationComplete, 'set-auto-invest-schedule'],
        [store.hasNextStepAsPersonalBrokerage, 'investment-selection'],
    ],
    'set-auto-invest-schedule': [
        [store.setScheduleAmountZero, 'referral'], //TODO: Valid transitions, but verify if you can set amount to 0 from UI
        [store.hasBankLinkedWithSetScheduleValuesAndRoboAsNextStep, 'first-deposit-summary'], // TODO: merge with below transition after Post launch
        [store.hasBankLinkedWithSetScheduleValuesAndPersonalAsNextStep, 'first-deposit-summary'], // TODO: merge with above transition after Post launch
        [store.setScheduleComplete, 'link-bank'], //TODO: should this go to link-bank-primer ??
        [store.skipToLinkBankPrimer, 'link-bank-primer'],
    ],
    'link-bank-primer': [
        [store.hasOnboardingComplete, 'referral'],
        [store.hasLinkBankPrimerComplete, 'link-bank'],
    ],
    'link-bank': [
        [store.hasOnboardingComplete, 'referral'],
        [store.hasBankLinkedWithSkipToLinkBankPrimer, 'referral'], // TODO: check if still valid
        [store.hasBankLinkedWithSetScheduleValuesAndRoboAsNextStep, 'first-deposit-summary'], // TODO: merge with below transition after Post launch
        [store.hasBankLinkedWithSetScheduleValuesAndPersonalAsNextStep, 'first-deposit-summary'], // TODO: merge with above transition after Post launch
    ],
    'first-deposit-summary': [[store.hasAutoInvestSmartSummaryComplete, 'first-deposit-success']],
    'first-deposit-success': [[store.hasSmartSuccessComplete, 'referral']],
};

const graph = {
    name: 'OnboardingGraphVoAM3',
    steps: OnboardingStepsVoaM3,
    transitions: OnboardingTransitionsVoAM3,
};

export default graph;
